export default "https://cdn-static.gokick.com/assets/30adf10d1d1967cb40501bfdbefb418f6cea25a6/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";